import React, { useContext, lazy, Suspense } from "react";
import "./Project.css";
import Button from "../../components/button/Button";
import Loading from "../loading/Loading";
import { socialMediaLinks } from "../../portfolio";
import StyleContext from "../../contexts/styleContext";

const Projects = () => {
  const { isDark } = useContext(StyleContext);

  //*  Lode important data first then ....
  const GithubRepoCard = lazy(() =>
    import("../../components/githubRepoCard/GithubRepoCard")
  );
  const FailedLoading = () => null;
  const renderLoader = () => <Loading />;
  // const [repo, setrepo] = useState([]);
  const repo = [
    {
      node: {
        screen: "sgam.png",
        name: "SGAM",
        description: "Sistema de Gestión de Archivo Municipal",
        forkCount: 0,
        stargazers: { totalCount: 0 },
        url: "https://sistema-gestion-archivo-municipal.vercel.app/",
        id: "MDEwOlJlcG9zaXRvcnkzNjg1MDMyNzA=",
        diskUsage: 1722,
        primaryLanguage: [
          { name: "NextJs", color: "#1F5FAA" },
          { name: "ReactJs", color: "#5ED3F3" },
          { name: "TailwindCss", color: "#38bdf8" },
        ],
      },
    },
    {
      node: {
        screen: "ahorcado.png",
        name: "Ahorcado",
        description: "Juego del Ahorcado",
        forkCount: 0,
        stargazers: { totalCount: 0 },
        url: "https://jhonbellidovargas.github.io/JUEGO_AHORCADO/",
        id: "MDEwOlJlcG9zaXRvcnkzMzczMjc2MDU=",
        diskUsage: 2738,
        primaryLanguage: [
          { name: "Html", color: "#e34c26" },
          { name: "Css", color: "#214ce5" },
          { name: "Javascript", color: "#f1e05a" },
        ],
      },
    },
    {
      node: {
        screen: "foxbel.png",
        name: "Foxbel Music",
        description: "Descubre y escucha música",
        forkCount: 0,
        stargazers: { totalCount: 0 },
        // url: "https://www.music.jhonbellido.tech/",
        url: "https://famous-platypus-b0aee0.netlify.app/",
        id: "MDEwOlJlcG9zaXRvcnkzMzczMjc2MDU=",
        diskUsage: 2738,
        primaryLanguage: [
          { name: "ReactJs", color: "#5ED3F3" },
          { name: "TailwindCss", color: "#38bdf8" },
        ],
      },
    },
    {
      node: {
        screen: "petgram.png",
        name: "PetGram",
        description: "Encuentra fotos de mascotas",
        forkCount: 0,
        stargazers: { totalCount: 0 },
        url: "https://petgram-gwx3z08av-jhonbellidovargas.vercel.app/",
        id: "MDEwOlJlcG9zaXRvcnkzMzczMjc2MDU=",
        diskUsage: 2738,
        primaryLanguage: [
          { name: "React", color: "#5ED3F3" },
          { name: "Graphql", color: "#E10098" },
        ],
      },
    },
    {
      node: {
        screen: "shop.png",
        name: "Stvx Shop",
        description: "Un proyecto de e-commerce",
        forkCount: 0,
        stargazers: { totalCount: 0 },
        url: "https://6201ad8e324be78d7ac0532c--cocky-montalcini-b695f6.netlify.app/",
        id: "MDEwOlJlcG9zaXRvcnkzNTEzNzA4MTk=",
        diskUsage: 45,
        primaryLanguage: [
          { name: "React", color: "#5ED3F3" },
          { name: "Sass", color: "#CC6699" },
          { name: "Node", color: "#339933" },
        ],
      },
    },
    {
      node: {
        screen: "pelis.png",
        name: "Pelis web",
        description: "Web de películas",
        forkCount: 0,
        stargazers: { totalCount: 0 },
        url: "https://dreamy-meitner-804b18.netlify.app/",
        id: "MDEwOlJlcG9zaXRvcnkzNTcwNjA1MjQ=",
        diskUsage: 227,
        primaryLanguage: [
          { name: "Html", color: "#e34c26" },
          { name: "Css", color: "#214ce5" },
          { name: "Javascript", color: "#f1e05a" },
        ],
      },
    },
    {
      node: {
        screen: "congreso.png",
        name: "COREINSI",
        description: "Congreso de Ingeniería de Sistemas",
        forkCount: 1,
        stargazers: { totalCount: 0 },
        url: "https://jhonbellidovargas.github.io/CongresoConf/",
        id: "MDEwOlJlcG9zaXRvcnkzNjQyOTUyMDA=",
        diskUsage: 5442,
        primaryLanguage: [{ name: "Bootstrap", color: "#563d7c" }],
      },
    },
    {
      node: {
        screen: "todos.png",
        name: "TODOS - App",
        description: "Web de Tareas",
        forkCount: 0,
        stargazers: { totalCount: 0 },
        url: "https://jhonbellidovargas.github.io/Todos-Web-React/",
        id: "MDEwOlJlcG9zaXRvcnkzNzg5MTY3MDY=",
        diskUsage: 4565,
        primaryLanguage: [{ name: "React", color: "#5ED3F3" }],
      },
    },
  ];

  if (!(typeof repo === "string" || repo instanceof String)) {
    return (
      <Suspense fallback={renderLoader()}>
        <div className="main" id="projects">
          <h1 className="project-title">Proyectos</h1>

          <div className="repo-cards-div-main">
            {repo.map((v, i) => {
              return (
                <GithubRepoCard repo={v} key={v.node.id} isDark={isDark} />
              );
            })}
          </div>

          <Button
            text={"Más proyectos"}
            className="project-button"
            href={socialMediaLinks.github}
            newTab={true}
          />
        </div>
      </Suspense>
    );
  } else {
    return <FailedLoading />;
  }
};

export default Projects;
